import { memo } from "react";
import { Box, Button, FormControlLabel, Radio, TextField, Typography, } from "@mui/material";
import { ReportSignatureData } from "../../../optionActions/types";
import { useTranslation } from "react-i18next";
import { useStyles } from "./styles";
import { CustomPaper } from "../../../../../../components/CustomPaper";
import { IOSSwitch } from "../../../../../../components/dynamicFormRef/switch";

interface SignatureItemProps {
    index: number;
    data: ReportSignatureData;
    onChange: (id: number, field: keyof ReportSignatureData, value: any) => void;
    onRemove?: (index: number) => void;
    haveDeleteButton: boolean
    errorDescription?: boolean;
}

export const SignatureItem = memo(({ index, data, onChange, onRemove, haveDeleteButton, errorDescription }: SignatureItemProps) => {
    const { t } = useTranslation()
    const styles = useStyles()

    return (
        <CustomPaper elevation={2} sx={styles.container} >
            <Box sx={styles.header}>
                <Typography color="primary" sx={{ fontWeight: 600 }}>
                    {t('Questionarie.signature')} {index + 1}
                </Typography>

                <Box sx={styles.title}>
                    <Typography sx={styles.titleText}>
                        {t('Questionarie.fields.requeiredSignature')}
                    </Typography>
                    <Radio
                        checked={data.requeired}
                        onClick={() => onChange(data.id, "requeired", !data.requeired)}
                        color="primary"
                    />
                </Box>
            </Box>

            <TextField
                fullWidth
                margin="dense"
                label={t('Questionarie.fields.signatureDescription')}
                value={data.description}
                onChange={(e) => onChange(data.id, "description", e.target.value)}
                error={errorDescription}
                helperText={errorDescription ? t('Questionarie.signatureDescriptionRequired') : ''}
                inputProps={{ maxLength: 255 }}
            />

            <Box sx={styles.footer}>
                <FormControlLabel
                    className='switch-check'
                    sx={styles.switch}
                    control={
                        <IOSSwitch
                            name='addComment'
                            checked={data.addComment}
                            onChange={(e) => onChange(data.id, "addComment", e.target.checked)}
                            sx={{ m: 1 }}
                        />
                    }
                    label={t('Questionarie.fields.addComment')}
                />

                {data.addComment && (
                    <Box sx={styles.title}>
                        <Typography sx={styles.titleText}>
                            {t('Questionarie.fields.required')}
                        </Typography>
                        <Radio
                            checked={!!data.reqiredComment}
                            onClick={() => onChange(data.id, "reqiredComment", !data.reqiredComment)}
                            color="primary"
                        />
                    </Box>
                )}
            </Box>

            {haveDeleteButton && <Box sx={styles.containerbuton}>
                <Button onClick={() => onRemove?.(data.id)}>
                    {t('general.delete')}
                </Button>
            </Box>}
        </CustomPaper>
    );
});
